import * as UI from "@iyk/ui"
import { Analytics, useAnalytics } from "@iyk/vf-observability/react"
import React from "react"

import { Link, Routes } from "./link.tsx"

export const ShopCard = () => {
  const analytics = useAnalytics()
  React.useEffect(() => {
    analytics.track_links("#shop-card", Analytics.Event.ShopCardClicked())
  }, [])

  return (
    <Link
      to={Routes.shop}
      id="shop-card"
      className="flex flex-col gap-4 justify-center items-center p-3 rounded border border-white/[10%] bg-white/[3%]"
    >
      <img
        src="https://assets.iyk.app/chance-the-rapper/shopify-shop/star_line_album_cd.png"
        alt="CD Cover"
        className="h-full max-h-40 aspect-square"
      />
      <div className="relative bottom-5 grid gap-4">
        <p className="text-xxl text-center">Star Line</p>
        <UI.Button kind="shaded" size="md" type="button">
          Order now
        </UI.Button>
      </div>
    </Link>
  )
}
